import React, { useRef, useEffect } from 'react';
import Type from 'prop-types';
import { usePrevious } from 'react-use';
import { getCalendarDate } from 'utils/date';
import Message from '../Message';
import DateSeparator from '../DateSeparator';

const MessageList = props => {
  const { uid, messages: messagesProp } = props;
  const bottomRef = useRef(null);
  const currentMessage = messagesProp[messagesProp.length - 1];
  const previousMessage = usePrevious(currentMessage);

  const scrollToBottom = () => {
    bottomRef.current.scrollIntoView();
  };

  const hasNewMessage = currentMessage?.id !== previousMessage?.id;

  useEffect(scrollToBottom, [messagesProp, hasNewMessage]);

  const insertDates = messages => {
    return messages.reduce((newMessages, message, idx) => {
      const messageDate = new Date(message.postedAt).toDateString();
      let prevMessageDate = messageDate;

      if (idx > 0) {
        const prevMessage = messages[idx - 1];
        prevMessageDate = new Date(prevMessage.postedAt).toDateString();
      }

      if (idx === 0 || messageDate !== prevMessageDate) {
        return [
          ...newMessages,
          { type: 'message.date', id: idx, postedAt: message.postedAt },
          { ...message, type: 'regular' },
        ];
      }

      return [...newMessages, { ...message, type: 'regular' }];
    }, []);
  };

  const renderMessageList = () => {
    const allMessages = insertDates(messagesProp);
    allMessages.sort((a, b) => a.postedAt - b.postedAt);

    return allMessages.reduce((elements, message) => {
      const isMe = message.uid === uid;

      if (message.type === 'message.date') {
        elements.push(
          <DateSeparator key={message.id} date={message.postedAt} formatDate={getCalendarDate} />,
        );
      }

      if (message.type === 'regular') {
        elements.push(<Message key={message.id} message={message} isMe={isMe} />);
      }

      return elements;
    }, []);
  };

  return (
    <>
      {renderMessageList()}

      <div key="bottom" ref={bottomRef} />
    </>
  );
};

MessageList.propTypes = {
  messages: Type.arrayOf(
    Type.shape({
      id: Type.string.isRequired,
      uid: Type.string.isRequired,
      postedAt: Type.string.isRequired,
      sender: Type.string.isRequired,
      text: Type.string.isRequired,
    }),
  ).isRequired,
  uid: Type.string.isRequired,
};

export default MessageList;
